import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import "./CaptainTCCards.css";
import captainTCCardImg from "../../images/captain-tc/captain-tc-card.jpeg";

const TEASER_CARDS = [
  {
    title: "£5 Card",
    description:
      "Each time you reach 250 TopCoin, you become eligible to receive £5, up to 20 times, until you complete the 5,000 TopCoin Captain TC Card promotion.",
  },
  {
    title: "£10 Card",
    description:
      "Each time you reach 250 TopCoin, you become eligible to receive £10, up to 20 times, until you complete the 5,000 TopCoin Captain TC Card promotion.",
  },
  {
    title: "£25 Card",
    description:
      "Each time you reach 250 TopCoin, you become eligible to receive £25, up to 20 times, until you complete the 5,000 TopCoin Captain TC Card promotion.",
  },
];

const HOW_IT_WORKS_STEPS = [
  "Buy your Captain TC Cash-Wallet Card.",
  "Collect TopCoin through participating merchants.",
  "Every TopCoin collected in your Main Wallet is matched 1-for-1 and added to your Cash Wallet Card balance.",
  "Each time you reach 250 TopCoin, a new Cash Wallet reward becomes available.",
  "Continue until you complete the 5,000 TopCoin Captain TC Card promotion.",
];

const CARD_OPTIONS = [
  {
    title: "£5 Card",
    purchaseReward: "Receive 5 TopCoin when you purchase the card.",
    reward:
      "Each time you reach 250 TopCoin, you become eligible to receive £5.",
    limit: "Up to 20 times per 5,000 TopCoin card promotion.",
  },
  {
    title: "£10 Card",
    purchaseReward: "Receive 10 TopCoin when you purchase the card.",
    reward:
      "Each time you reach 250 TopCoin, you become eligible to receive £10.",
    limit: "Up to 20 times per 5,000 TopCoin card promotion.",
  },
  {
    title: "£25 Card",
    purchaseReward: "Receive 25 TopCoin when you purchase the card.",
    reward:
      "Each time you reach 250 TopCoin, you become eligible to receive £25.",
    limit: "Up to 20 times per 5,000 TopCoin card promotion.",
  },
];

const CaptainTCCards = () => {
  const scrollToCardOptions = () => {
    document.getElementById("captain-tc-card-options")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle
            pageTitle={"Captain TC Cash-Wallet Card"}
            pagesub={"Home"}
          />
          <div className="captain-tc-cards-page">
            <div className="captain-tc-content">
              {/* Section 1 — Intro */}
              <section className="captain-tc-section captain-tc-intro-section">
                <h1 className="captain-tc-page-title">
                  Captain TC Cash-Wallet Card
                </h1>
                {/* Hero Card Image */}
                <section className="captain-tc-hero">
                  <div className="captain-tc-card-image-wrapper">
                    <img
                      src={captainTCCardImg}
                      alt="Captain TC Card - TopCoin Collectible Series Founder Edition"
                      loading="lazy"
                    />
                  </div>
                </section>
                <p className="captain-tc-text">
                  A special reward card from TopCoin UK that gives you access to
                  the Captain TC Cash-Wallet promotion.
                </p>
                <p className="captain-tc-text">
                  Each series contains{" "}
                  <span className="gold-highlight">5,000 cards</span> only. Once
                  a series is completed, no more cards will be issued in that
                  series.
                </p>
                <p className="captain-tc-text">
                  Every TopCoin collected in your Main Wallet is matched{" "}
                  <span className="gold-highlight">1-for-1</span> and added to
                  your Cash Wallet Card balance.
                </p>
                <p className="captain-tc-text">
                  TopCoins from all participating shops and retailers are added
                  together. Every time your total reaches 250 TopCoin, you will
                  receive the reward linked to your chosen Captain TC card.
                </p>
                <h2 className="captain-tc-intro-subtext">Choose your card:</h2>

                <div className="captain-tc-teaser-cards">
                  {TEASER_CARDS.map((card) => (
                    <div
                      key={card.title}
                      className="captain-tc-card-tier captain-tc-teaser-card"
                    >
                      <h3 className="benefit-title">{card.title}</h3>
                      <p className="benefit-description">{card.description}</p>
                    </div>
                  ))}
                </div>

                <p className="captain-tc-text captain-tc-withdrawal-note">
                  Withdrawals are handled by our FCA-authorised payment partner.
                  A <span className="gold-highlight">2% processing fee</span>{" "}
                  applies to each withdrawal.
                </p>

                <div className="captain-tc-cta-wrapper">
                  <button
                    type="button"
                    className="captain-tc-cta"
                    onClick={scrollToCardOptions}
                  >
                    Buy Your Captain TC Card
                  </button>
                </div>
              </section>

              <hr className="captain-tc-divider" />

              {/* Section 2 — How it works */}
              <section className="captain-tc-section captain-tc-how-section">
                <h2 className="captain-tc-section-title">
                  How the Captain TC Cash-Wallet Card works
                </h2>

                {HOW_IT_WORKS_STEPS.map((step, index) => (
                  <div key={step} className="captain-tc-benefit-card">
                    <div className="benefit-number">{index + 1}</div>
                    <div className="benefit-body">
                      <p className="benefit-description">{step}</p>
                    </div>
                  </div>
                ))}

                <div className="captain-tc-cta-wrapper">
                  <button
                    type="button"
                    className="captain-tc-cta"
                    onClick={scrollToCardOptions}
                  >
                    View Card Options
                  </button>
                </div>
              </section>

              <hr className="captain-tc-divider" />

              {/* Section 3 — Card options */}
              <section
                id="captain-tc-card-options"
                className="captain-tc-section captain-tc-options-section"
              >
                <h2 className="captain-tc-section-title">
                  Choose Your Captain TC Cash-Wallet Card
                </h2>

                <div className="captain-tc-card-tiers">
                  {CARD_OPTIONS.map((card) => (
                    <div key={card.title} className="captain-tc-card-tier">
                      <h3 className="benefit-title">{card.title}</h3>
                      <p className="benefit-description">
                        {card.purchaseReward}
                      </p>
                      <p className="benefit-description">{card.reward}</p>
                      <p className="benefit-description">{card.limit}</p>
                    </div>
                  ))}
                </div>

                <div className="captain-tc-cta-wrapper">
                  <button
                    type="button"
                    className="captain-tc-cta"
                    onClick={scrollToCardOptions}
                  >
                    Select Your Card
                  </button>
                </div>
              </section>

              <hr className="captain-tc-divider" />

              {/* Section 4 — Why buy */}
              <section className="captain-tc-section captain-tc-why-section">
                <h2 className="captain-tc-section-title">
                  Why buy a Captain TC Cash-Wallet Card?
                </h2>
                <p className="captain-tc-text">
                  Your card helps your TopCoin grow faster and gives you access
                  to repeated Cash Wallet rewards every time you reach{" "}
                  <span className="gold-highlight">250 TopCoin</span>.
                </p>
              </section>
            </div>
          </div>
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default CaptainTCCards;
